import React from "react";
import { useLocation } from "react-router-dom";
import usePrivateLink from "../config/usePrivateLink";
import ModuleHeader from "../components/ModuleHeader/ModuleHeader";

const tabs = [
  {
    id: "schedule",
    title: "Schedule",
    icon: "ri-calendar-2-line",
    path: "/schedule",
    activePaths: [
      "/schedule",
      "/schedule/edit",
      "/schedule/add",
      "/schedule/delete",
    ],
  },
  {
    id: "timetableManage",
    title: "Timetable Manage",
    icon: "ri-settings-3-line",
    path: "/timetable/manage",
    activePaths: ["/timetable/manage"],
  },
  {
    id: "timeTable",
    title: "Time Table",
    icon: "ri-calendar-schedule-line",
    path: "/timetable",
    activePaths: ["/timetable", "/timetable/print"],
  },
  {
    id: "dayWise",
    title: "Day Wise",
    icon: "ri-calendar-2-line",
    path: "/timetable/day/wise",
    activePaths: ["/timetable/day/wise"],
  },
];

export default function Master({ children }) {
  return;
  const hasAccess = usePrivateLink();

  const visibleTabs = tabs.filter((tab) =>
    hasAccess(tab.path)
  );

  return (
    <>
      <div className="mt-4">
        <ModuleHeader tabs={visibleTabs} />
        {children}
      </div>
    </>
  );
}